import * as React from 'react';
import { Button,Icon } from '@alifd/next';
//@ts-ignore
import Alitalk from '@alife/icbu-alitalk-react';


export default function ChatNow(props:any) {
  const {
    i18n,
    productOwnMemberAlitalkEncryptId,
    baoAccountIsService,
    baoAccountIsDisplayAssurance,
    productId,
    bucket,
  } = props;

  const isXb = baoAccountIsService ? 1 : 0;
  const isDa = baoAccountIsDisplayAssurance ? 1 : 0;

  const domdot=`id:3302,ext:'is_xinbao_product=${isXb}|is_display_assurance=${isDa}'`

  // 场景来源参数
  const scene = {
    fromPage: 'product_detail',
    bizType: 'chat_now',
    bucket: bucket || '',
  };


  return (
    <Alitalk
        uid={productOwnMemberAlitalkEncryptId}
        pid={productId}
        bizType="1"
        bizId={productId}
        action="chatNow"
        sceneType="detail"
        scene={scene} // 场景来源参数
      >
        <div
          className={`bc-alitalk-wrapper alitalk-action`}
          data-domdot={`${domdot}|status=online`}
          style={{
            textAlign: "center"
          }}
        >
          <Button text type='primary'><Icon type="atm" /> {i18n["rightAction.chat"]}</Button>
        </div>
      </Alitalk>
  )
}
